import { Component } from '@angular/core'

@Component({
  selector: '[app-select-menu-list-no-items-item]',
  template: `
    <p>No results found!</p>
    `,
  styles: `
    :host {
      margin: 0;
      padding: 0.75rem;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 0.25rem;
      text-align: center;
      text-wrap: auto;
      white-space: normal;
      line-height: 1rem;
      font-weight: normal;
    }
    `,
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SelectMenuListNoItemsComponent {}
